<h2 class="webapp-title-secondary">{{sectionInfo.title}}</h2>
<div class="grid grid-cols-2 album-grid">
    <span class="square-link">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/ea504788-f24f-4b40-c8db-b340d4711f00/public" alt="">
        <div class="album-details">
            <div class="album-title">Idealista</div>
            <a class="album-author" href="https://www.idealista.com" target="_blank">idealista.com</a>
        </div>
    </span>

    <span class="square-link">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/2fc5289c-2959-4bb9-f4f2-938719952b00/public" alt="">
        <div class="album-details">
            <div class="album-title">Spotahome</div>
            <a class="album-author" href="https://www.spotahome.com" target="_blank">spotahome.com</a>
        </div>
    </span>

    <span class="square-link">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/a75298ff-b83d-4004-53b7-ec6b42896200/public" alt="">
        <div class="album-details">
            <div class="album-title">HomeLike</div>
            <a class="album-author" href="https://www.thehomelike.com" target="_blank">thehomelike.com</a>
        </div>
    </span>

    <span class="square-link">
        <img src="https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/74dc2441-152f-4779-ce71-3ccef407c600/public" alt="">
        <div class="album-details">
            <div class="album-title">Airbnb</div>
            <a class="album-author" href="https://www.airbnb.es" target="_blank">airbnb.es</a>
        </div>
    </span>
</div>